import { withMetadata } from '../metadata'
import { parsePhoneNumberWithError as _parsePhoneNumberWithError } from '../../core/index'

export function parsePhoneNumberWithError() {
	return withMetadata(_parsePhoneNumberWithError, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/parsePhoneNumberWithError.js
// module id = wPsd
// module chunks = 0 1